import styled from '@emotion/styled';
import { useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { TitreForm } from '../components/TitreForm';

const Container = styled.div`
  min-height: calc(100vh - 76px);
  background:
    radial-gradient(circle at 8% 0%, rgba(255, 79, 31, 0.08), transparent 24%),
    radial-gradient(circle at 90% 8%, rgba(255, 176, 0, 0.08), transparent 20%),
    var(--mt-bg);
  color: var(--mt-text);

  .bread-crum span {
    color: var(--mt-text);
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: var(--mt-row-odd);
    color: var(--mt-text);
  }

  .even-row {
    background-color: var(--mt-row-odd);
    color: var(--mt-text);
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: var(--mt-text);
    }
  }

  .content {
    padding: 12px;
    width: 100%;
    color: var(--mt-text);
  }

  .form-panel {
    width: 100%;
  }

  .issue-hero {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 18px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.14), transparent 38%),
      ${PRIMARY};
    box-shadow: var(--mt-card-shadow);
  }

  .hero-copy {
    display: flex;
    align-items: flex-start;
    gap: 14px;
  }

  .back-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: 1px solid rgba(255, 176, 0, 0.24);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.06);
    color: ${YELLOW};
    cursor: pointer;
    transition: 0.2s ease;
  }

  .back-button:hover {
    border-color: rgba(255, 176, 0, 0.58);
    background: rgba(255, 176, 0, 0.12);
  }

  .eyebrow {
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .issue-hero h1 {
    margin: 5px 0 0;
    color: #fff7e8;
    font-family: Poppins-B;
    font-size: 30px;
    line-height: 1.1;
  }

  .issue-hero p {
    max-width: 760px;
    margin: 8px 0 0;
    color: rgba(255, 247, 232, 0.72);
    line-height: 1.5;
  }

  .hero-badge {
    border: 1px solid rgba(255, 176, 0, 0.26);
    border-radius: 8px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.06);
    color: #fff7e8;
    min-width: 170px;
  }

  .hero-badge span {
    display: block;
    color: rgba(255, 247, 232, 0.62);
    font-size: 10px;
    letter-spacing: 0.07em;
    text-transform: uppercase;
  }

  .hero-badge strong {
    display: block;
    margin-top: 4px;
    color: ${YELLOW};
    font-family: Poppins-B;
  }

  @media (max-width: 760px) {
    .content {
      padding: 18px 12px;
    }

    .issue-hero {
      align-items: stretch;
      flex-direction: column;
    }
  }
`;

export const NewTitrePage = () => {
  const history = useHistory();

  useEffect(() => {}, []);

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div className='form-panel'>
            <section className='issue-hero'>
              <div className='hero-copy'>
                <button
                  className='back-button'
                  type='button'
                  onClick={() => history.goBack()}
                  aria-label='Retour'
                >
                  <FaArrowLeft size={16} />
                </button>
                <div>
                  <span className='eyebrow'>Portefeuille des titres</span>
                  <h1>Émettre un nouveau titre</h1>
                  <p>
                    Créez le titre, rattachez le détenteur et chargez la pièce
                    de contrôle dans un flux unique de back-office.
                  </p>
                </div>
              </div>
              <div className='hero-badge'>
                <span>Flux</span>
                <strong>Émission & livraison</strong>
              </div>
            </section>

            <TitreForm />
          </div>
        </div>
      </Container>
    </Layout>
  );
};
